module.exports = __webpack_public_path__ + "static/img/privacyImg.6bcf23e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/privacyImg.jpg
// module id = 0sJ6
// module chunks = 2